/** For US and CA market price per night is calculated from subtotal instead of total : https://stayforlong.atlassian.net/browse/CONV-1472 */
export function calculatePricePerNight({ subtotal, pricePerNight, nights, market }) {
  const marketsPricePerNightFromSubtotal = ['us', 'ca', 'au']
  let output = ''

  if (marketsPricePerNightFromSubtotal.includes(market) && subtotal && nights) {
    output = subtotal / nights
  }

  if (!marketsPricePerNightFromSubtotal.includes(market) && pricePerNight) {
    output = pricePerNight
  }

  if (output && Number.isInteger(output)) {
    return output
  }

  if (output && !Number.isInteger(output)) {
    return parseFloat(output.toFixed(2))
  }

  return ''
}

export function isTimePassed(initialTime, offset) {
  const currentTime = new Date().getTime()
  const difference = currentTime - initialTime
  return difference >= offset
}
